import classNames from "classnames";
import { motion, useTransform, motionValue } from "framer-motion";
import React, { useEffect, useState } from "react";
import background1 from "./images/card-1.svg?url";
import background2 from "./images/card-2.svg?url";
import { useWindowSize } from "../../hooks/useWindowSize";

const images = {
  "card-1.svg": background1,
  "card-2.svg": background2,
};

type BFCardsProps = {
  index: number;
  badge: string;
  title: string;
  background: "card-1.svg" | "card-2.svg";
};

type Card = {
  badge: string;
  title: string;
  background: "card-1.svg" | "card-2.svg";
};

const cards: Card[] = [
  {
    badge: "Protect",
    title: "Bitcoin Inheritance\nTechnology",
    background: "card-1.svg",
  },
  {
    badge: "Protect",
    title: "Bitcoin Tax\nTechnology",
    background: "card-1.svg",
  },
  {
    badge: "Protect",
    title: "Bitcoin Financial\nPlanning",
    background: "card-1.svg",
  },
  {
    badge: "Build",
    title: "Bitcoin\nPrivate Equity",
    background: "card-2.svg",
  },
  {
    badge: "Build",
    title: "Bitcoin\nPublic Shares",
    background: "card-2.svg",
  },
  {
    badge: "Build",
    title: "Buy Bitcoin\n& Stake ETH",
    background: "card-2.svg",
  },
];

const ukCards: Card[] = [
  {
    badge: "Manage",
    title: "Bitcoin Inheritance\nTechnology",
    background: "card-1.svg",
  },
  {
    badge: "Manage",
    title: "Bitcoin Tax\nTechnology",
    background: "card-1.svg",
  },
  {
    badge: "Manage",
    title: "Bitcoin Financial\nPlanning",
    background: "card-1.svg",
  },
  {
    badge: "Build",
    title: "Convert FIAT\nto Stablecoins",
    background: "card-2.svg",
  },
  {
    badge: "Build",
    title: "Stake ETH",
    background: "card-2.svg",
  },
  {
    badge: "Build",
    title: "Buy Bitcoin",
    background: "card-2.svg",
  },
];

const BFCards = ({ index, badge, title, background }: BFCardsProps) => {
  const { isMobile } = useWindowSize();

  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const docHeight =
        document.documentElement.scrollHeight - window.innerHeight;
      const progressValue = docHeight > 0 ? scrollTop / docHeight : 0;

      setProgress(progressValue);
    };

    window.addEventListener("scroll", handleScroll);

    handleScroll();

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [progress]);

  const isProtect = badge === "Protect" || badge === "Manage";

  const translateX = useTransform(
    motionValue(progress),
    [0, isMobile ? 0.01 : 0.04],
    [
      isMobile ? 0 : 40 - index * 10,
      isMobile ? 100 - index * 40 : 330 - index * 130,
    ]
  );
  const rotate = useTransform(
    motionValue(progress),
    [0, isMobile ? 0.01 : 0.03],
    [0, isMobile ? 2 - index * 0.8 : 2 - index * 0.8]
  );

  const cardWidth = isMobile ? "100px" : "300px";
  const cardHeight = isMobile ? "140px" : "425px";
  const paddingLeft = isMobile ? "ml-1" : "ml-10";
  const paddingTop = isMobile ? "mt-1" : "mt-10";
  const badgeTextSize = isMobile ? "text-[6px]" : "text-[14px]";

  return (
    <motion.div
      className="absolute flex items-start justify-center overflow-hidden rounded-lg mx-auto hover:z-10 md:hover:z-auto transition-all"
      style={{
        width: cardWidth,
        height: cardHeight,
        perspective: "800px",
        transform: `translateX(${translateX.get()}px) rotate(${rotate.get()}deg)`,
        backgroundImage: `url(${images[background]})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className={`p-5 z-10 text-left w-full ${paddingLeft} ${paddingTop}`}>
        <span
          className={classNames(
            `inline-block text-white ${badgeTextSize} rounded-[6px] px-2 py-1 mb-2 uppercase`,
            {
              "bg-primary-dark": isProtect,
              "bg-primary-regular": !isProtect,
            }
          )}
        >
          {badge}
        </span>
        <div className={`text-white md:text-sm text-[5px]`}>
          {title.split("\n").map((line, idx) => (
            <React.Fragment key={idx}>
              {line}
              <br />
            </React.Fragment>
          ))}
        </div>
      </div>
    </motion.div>
  );
};

export const BFCardsList = ({ isUk }: { isUk: boolean }) => {
  return (
    <div
      style={{
        background: "linear-gradient(to bottom, #410A9F, #7201A2)",
      }}
      className="w-full rounded-[20px]"
    >
      <h4 className="text-white text-center mb-7 pt-8">
        The All-in-One Bitcoin Investment Platform
      </h4>

      <div className="relative w-full md:w-[300px] md:h-[425px] h-[150px] mx-auto flex justify-center mb-[60px] md:mb-[80px]">
        {(isUk ? ukCards : cards)
          .map((card, index) => (
            <BFCards
              key={index}
              index={index}
              badge={card.badge}
              background={card.background}
              title={card.title}
            />
          ))
          .reverse()}
      </div>
    </div>
  );
};
